/* eslint-disable @typescript-eslint/no-unused-vars */

import { FC, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import useAppealButtonFunc from "src/hooks/useAppealButtonFunc";
import { statetype } from "src/pages/dashboard/types";
import { ManufacturerNextStepActionsProps } from "./types";
import { PrecertAPIResponse } from "src/pages/precert/types";
import RequestDateOfTreatment from "../modals/requestDateOfTreatment";
import TreatmentDecision from "../modals/treatmentDecision";

const ManufacturerNextStepActions: FC<ManufacturerNextStepActionsProps> = ({ kase, refreshListing, next_steps }): JSX.Element => {

  const navigate = useNavigate();
  const [precertPathParameters, setPrecertPathParameters] = useState<statetype>()
  const { apiInPorgress } = useAppealButtonFunc();

  const [requestTreatmentModal, setRequestTreatmentModal] =
    useState<{
      isModalVisible: boolean;
      caseId: number;
      prescriptionId: number;
      bentype: string;
    }>({
      isModalVisible: false,
      caseId: 0,
      prescriptionId: 0,
      bentype: "",
    });
  const [treatmentDecisionModal, setTreatmentDecisionModal] = useState<{
    isModalVisible: boolean;
    caseId: number;
    prescriptionId: number;
    prior_authorization_id: number;
    prior_auth_status: string | null;
    kase?: any;
  }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0,
    prior_authorization_id: 0,
    prior_auth_status: "",
  });


  const { mutate: fetchPrecertMutate, data: fetchPrecertResponse } =
    useFetch<PrecertAPIResponse>(APIEndpoints.FETCH_PRECERT, {}, {}, false);

  useEffect(() => {
    if (fetchPrecertResponse) {
      navigate(`/cases/${precertPathParameters && precertPathParameters.case_id}/precerts/${precertPathParameters && precertPathParameters.id}/edit?insuranceName=${precertPathParameters && precertPathParameters.insurance_name}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchPrecertResponse]);
  const navigateToPrecertForm = (caseId: number, precertId: number, insuranceName: string) => {
    const pathParams = {
      case_id: caseId,
      id: precertId
    }
    setPrecertPathParameters(pathParams)
    fetchPrecertMutate({}, pathParams)
    let pathParam = { insurance_name: insuranceName, ...pathParams }
    setPrecertPathParameters(pathParam)
  }
  const navigateToUpdatePrecertForm = (caseId: number, precertId: number, patient: string, insurance_name: string) => {
    navigate(`/cases/${caseId}/precert/${precertId}/edit?patient=${patient}&insuranceName=${insurance_name}`);
  }
  const navigateToReviewPrecertForm = (caseId: number, precertId: number, title: string, patient: string, insurance_name: string) => {
    navigate(`/cases/${caseId}/precerts/${precertId}/review?title=${title + " " + caseId}&precert_id=${precertId}&patient=${patient}&insuranceName=${insurance_name}`,
    );
  }
  const navigateToReviewRXPrecertForm = (caseId: number, precertId: number, title: string, patient: string, insurance_name: string) => {
    navigate(`/cases/${caseId}/prior_authorizations/${precertId}?title=${title + " " + caseId}&precert_id=${precertId}&patient=${patient}&insuranceName=${insurance_name}`, {
      state: { title: title + " " + caseId, precert_id: precertId, patient: patient }
    });
  }
  const naviagteToRX_PA = (kase: any, precert_id: number, insurance_name: string) => {
    navigate(`/cases/${kase.bi_case_id}/documents/new?precert_id=${precert_id}&insuranceName=${insurance_name}`)
  }
  const naviagteToUpdateRX_PA = (kase: any, precert_id: number, insurance_name: string) => {
    //priorAuthorization
    navigate(`/cases/${kase.bi_case_id}/prior_authorizations/${precert_id}/edit?precert_id=${precert_id}&patient=${kase.patient_name}&insuranceName=${insurance_name}`, {
      state: { precert_id: kase.precert_id, patient: kase.patient_name }
    })

  }



  let actions: (JSX.Element | null)[] = [];

  // Precert buttons
  if (next_steps?.precert_buttons?.length > 0) {
    actions.push(
      ...next_steps.precert_buttons.map((btn: any) =>
        btn.precert ? (
          <button
            className="btn btn-warning btn-sm m-1"
            key={`precert-${btn.key}`}
            onClick={() =>
              btn.precert_id &&
              navigateToPrecertForm(kase.bi_case_id, btn.precert_id, btn.ins_name)
            }
            title={btn.ins_name}
          >
              Precert
          </button>
        ) : null
      )
    );
  }

  // Update buttons
  if (next_steps?.update_buttons?.length > 0) {
    actions.push(
      ...next_steps.update_buttons.map((btn: any) =>
        btn.update ? (
          <button
            className="btn btn-warning m-1 btn-sm m-1"
            key={`update-${btn.key}`}
            disabled={apiInPorgress}
            title={btn.ins_name}
            onClick={() =>
              btn.precert_status === "submitted"
                ? btn.precert_id &&
                navigateToUpdatePrecertForm(
                  kase.bi_case_id,
                  btn.precert_id,
                  kase.patient_name,
                  btn.ins_name
                )
                : btn.precert_id &&
                navigateToPrecertForm(kase.bi_case_id, btn.precert_id, btn.ins_name)
            }
          >
             Update PA
          </button>
        ) : null
      )
    );
  }

  // Review buttons
  // if (next_steps?.review_buttons?.length > 0) {
  //   actions.push(
  //     ...next_steps.review_buttons.map((btn: any) =>
  //       btn.review ? (
  //         <button
  //           className="btn btn-warning btn-sm m-1"
  //           key={`review-${btn.key}`}
  //           title={btn.ins_name}
  //           onClick={() =>
  //             btn.precert_id &&
  //             navigateToReviewPrecertForm(
  //               kase.bi_case_id,
  //               btn.precert_id,
  //               "Review Med PA For Case",
  //               kase.patient_name,
  //               btn.ins_name
  //             )
  //           }
  //         >
  //            Review PA
  //         </button>
  //       ) : null
  //     )
  //   );
  // }

  // RX PA buttons
  if (next_steps?.rx_pa_buttons?.length > 0) {
    actions.push(
      ...next_steps.rx_pa_buttons.map((btn: any) =>
        btn.rx_pa ? (
          <button
            className="btn btn-warning btn-sm m-1 text-nowrap"
            key={`rxpa-${btn.key}`}
            title={btn.ins_name}
            disabled={apiInPorgress}
            onClick={() => naviagteToRX_PA(kase, btn.prior_authorization_id, btn.ins_name)}
          >
             RX PA
          </button>
        ) : null
      )
    );
  }

  // Review RX PA buttons
  // if (next_steps?.review_pa_buttons?.length > 0) {
  //   actions.push(
  //     ...next_steps.review_pa_buttons.map((btn: any) =>
  //       btn.review_pa ? (
  //         <button
  //           className="btn btn-warning btn-sm m-1"
  //           key={`reviewpa-${btn.key}`}
  //           disabled={apiInPorgress}
  //           title={btn.ins_name}
  //           onClick={() =>
  //             btn.prior_authorization_id &&
  //             navigateToReviewRXPrecertForm(
  //               kase.bi_case_id,
  //               btn.prior_authorization_id,
  //               "Review RX PA For Case",
  //               kase.patient_name,
  //               btn.ins_name
  //             )
  //           }
  //         >
  //            Review RX PA
  //         </button>
  //       ) : null
  //     )
  //   );
  // }

  // Update RX PA buttons
  if (next_steps?.update_pa_buttons?.length > 0) {
    actions.push(
      ...next_steps.update_pa_buttons.map((btn: any) =>
        btn.update_pa ? (
          <button
            className="btn btn-warning btn-sm m-1 text-nowrap"
            key={`updatepa-${btn.key}`}
            disabled={apiInPorgress}
            title={btn.ins_name}
            onClick={() => naviagteToUpdateRX_PA(kase, btn.prior_authorization_id, btn.ins_name)}
          >
             Update RX PA
          </button>
        ) : null
      )
    );
  }


  // Date of treatment
  // if (next_steps?.date_of_treatment) {
  //   actions.push(
  //     <button
  //       key="date-treatment"
  //       className="btn btn-success btn-sm m-1"
  //       onClick={() =>
  //         setRequestTreatmentModal({
  //           isModalVisible: true,
  //           caseId: kase.bi_case_id,
  //           prescriptionId: kase.prescription_id,
  //           bentype: "",
  //         })
  //       }
  //     >
  //       Date of Treatment
  //     </button>
  //   );
  // }

  // Treatment decision
  // if (next_steps?.treatment_decision) {
  //   actions.push(
  //     <button
  //       key="treatment-decision"
  //       className="btn btn-primary btn-sm m-1 text-nowrap"
  //       title="Click here to transfer to pharmacy or indicate treatment decision"
  //       disabled={true}
  //       onClick={() =>
  //         setTreatmentDecisionModal({
  //           isModalVisible: true,
  //           caseId: kase.bi_case_id,
  //           prescriptionId: kase.prescription_id,
  //           prior_authorization_id: kase.prior_auth_id ? kase.prior_auth_id : 0,
  //           prior_auth_status: "",
  //           kase: kase,
  //         })
  //       }
  //     >
  //       Treatment Decision
  //     </button>
  //   );
  // }

  if (next_steps?.copay_claim) {
    actions.push(
      <Link to={`/cases/${kase.id}/copay`} className="btn btn-copay m-1 text-decoration-none">
        <i className="bi bi-file-earmark-text me-2"></i>
        Copay Claim
      </Link>
    )
  }
  // No action required
  if (next_steps?.no_action_required) {
    //console.log('actions.length',actions.length)
    actions.push(<p key="no-action" className="mb-0">No Action Required</p>);
  }


  return (
    <>
      {actions}
      {requestTreatmentModal.isModalVisible && (
        <RequestDateOfTreatment
          {...requestTreatmentModal}
          hideModal={() =>
            setRequestTreatmentModal({
              isModalVisible: false,
              caseId: 0,
              prescriptionId: 0,
              bentype: "",
            })
          }
          refreshListing={refreshListing}
        />
      )}
      {treatmentDecisionModal.isModalVisible && (
        <TreatmentDecision
          {...treatmentDecisionModal}
          hideModal={() =>
            setTreatmentDecisionModal({
              isModalVisible: false,
              caseId: 0,
              prescriptionId: 0,
              prior_authorization_id: 0,
              prior_auth_status: "",
            })
          }
          refreshListing={refreshListing}
        />
      )}
    </>
  );
};

export default ManufacturerNextStepActions;
